import useLocale from '../../../hooks/useLocale';
import StatusTag from './StatusTag';
import type { EventStatus } from './types';
import { getEventStatusLabel, getEventStatusPresentation } from './utils';

interface IProps {
  status?: EventStatus;
}

const EventStatusTag = ({ status }: IProps): JSX.Element => {
  const { t } = useLocale();

  return <StatusTag presentation={getEventStatusPresentation(status)} label={getEventStatusLabel(status, t)} />;
};

export default EventStatusTag;
